import React, {useEffect} from 'react'
import t from 'helpers/I18n'
import PropTypes from 'prop-types'
import BaseParagraph from "components/base-components/base-paragraph";
import illustration from "components/../assets/svg/group54_OLD.svg"
import BaseButton from "components/base-components/base-button";
import StepsWrapper from "steps/steps-wrapper";
import StepsLoader from "steps/steps-loader";
import { AppDataContext } from '../../../contexts/app-data';


const IntroLegal = () => {
    const lang = localStorage.getItem('language')
    const { state, dispatch } = React.useContext(AppDataContext)

        useEffect(() => {
        if (window.PageBus) {
            window.PageBus.publish("analyticsServices", {
                pageID: "onboarding",
                stepSeq: "1",
                stepName: "personal info:confirmed",
                eventAction: "stepEnd",
                flowType: "sales",
                flowName: "onboarding",
                productName: "onboarding",
                trackMethod: "flow"
             }
            );
        }
     }, [])
    return (
        <div className={"intro-step"}>
            {/* <StepsWrapper stepGroupTitle={t("general.legal_questions")} loaded={0.1} title={t('general.open_vue_pro_account')}> */}
            <StepsWrapper stepGroupTitle={t("general.legal_questions")} loaded={0.1}>
                <StepsLoader>

                    <BaseParagraph  illustration={illustration} />
                    <BaseParagraph  align={"center"} >
                        <h3>{t('financial_infos.financial_info_intro.title')}</h3>
                        <p>{t('financial_infos.financial_info_intro.text')}</p>
                    </BaseParagraph>

                    <div className={"footer-action"} style={{bottom: state.footer_height}}>
                        <BaseButton caption={t('general.continue')} link={`/${lang.toLowerCase()}/legal-steps/usage`}/>
                    </div>
                </StepsLoader>
            </StepsWrapper>
        </div>

    )
}

IntroLegal.propTypes = {
    name: PropTypes.string
}

IntroLegal.defaultProps = {
    name: "Step02"
}


export default IntroLegal